/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { TERMINAL_STATUSES } from '@hbrisk/sp3-risk-model-support/schemas/extraction/index.js';

// Derived from the shared contract's TERMINAL_STATUSES (which also includes the
// success terminus, PROPOSAL_READY) rather than hand-duplicated, so this can't drift
// from the contract independently.
export const TERMINAL_ERROR_STATUSES = TERMINAL_STATUSES.filter(
  status => status !== 'PROPOSAL_READY'
);

/**
 * Given a `getResponse`-shaped job status payload (data & API design §2.2), decides what
 * the creation-flow progress view (UI design §2.2/§2.4) does next:
 *   - `enterModel` (PROPOSAL_READY) -- the only status that navigates into the model.
 *   - `isTerminalError` (one of the three terminal-error statuses, AU-9) -- stop polling,
 *     show the job's `reason`, and offer "try another document"; never enter the model.
 *   - `stopPolling` -- true for any terminal status (PROPOSAL_READY or an error), so the
 *     progress view knows to stop scheduling another poll.
 * Pure and independent of timers/dispatch, so it's unit-testable without a component
 * render harness -- this is what a live poll AND a reload that rediscovers a job already in
 * one of these states both funnel through, so both paths get identical treatment.
 */
const resolveExtractionJobAction = ({ status }) => ({
  enterModel: status === 'PROPOSAL_READY',
  isTerminalError: TERMINAL_ERROR_STATUSES.includes(status),
  stopPolling: TERMINAL_STATUSES.includes(status),
});

export default resolveExtractionJobAction;
